import auth from "./auth";

export const getRoutes = () => {
  return auth.list;
};
